












import Vue from 'vue'
import { Component } from 'vue-property-decorator';
import ShareReportDialog from './share-report-dialog.vue'
import ExportCSV from './export-csv.vue'
import CreateCampaign from '@/views/reports/forms/campaign/create.vue';
import EditCampaign from '@/views/reports/forms/campaign/edit.vue';
import DuplicateCampaign from '@/views/reports/forms/campaign/duplicate.vue';
import CreateOffer from '@/views/reports/forms/offer/create.vue';
import EditOffer from '@/views/reports/forms/offer/edit.vue';
import DuplicateOffer from '@/views/reports/forms/offer/duplicate.vue';
import CreateLanding from '@/views/reports/forms/landing/create.vue';
import EditLanding from '@/views/reports/forms/landing/edit.vue';
import DuplicateLanding from '@/views/reports/forms/landing/duplicate.vue';
import CreateFlow from '@/views/reports/forms/flow/create.vue';
import EditFlow from '@/views/reports/forms/flow/edit.vue';
import DuplicateFlow from '@/views/reports/forms/flow/duplicate.vue';
import CreateTrafficSources from '@/views/reports/forms/traffic_sources/create.vue';
import EditTrafficSource from '@/views/reports/forms/traffic_sources/edit.vue';
import ChangeWorkspace from './change-workspace-dialog.vue'
import DuplicateTrafficSource from '@/views/reports/forms/traffic_sources/duplicate.vue';
import CreateAffiliateNetworks from '@/views/reports/forms/affiliate_network/create.vue';
import EditAffiliateNetworks from '@/views/reports/forms/affiliate_network/edit.vue';
import DuplicateAffiliateNetworks from '@/views/reports/forms/affiliate_network/duplicate.vue';
import UpdateCost from '@/views/reports/forms/campaign/cost/update-cost.vue';
import CampaignLinks from '@/views/reports/forms/campaign/links/links-form.vue';
import LpPixel from '@/views/reports/forms/campaign/links/lp-pixel/lp-pixel-form.vue';
import TrackConversionsWithNoClickIds from '@/views/reports/forms/campaign/links/track-conversions-with-no-click-ids.vue';
import ColumnsSettingsDialog from '@/views/reports/pickers/cores/columns-settings-dialog/columns-settings-dialog.vue';
import AddNewColumnDialog from '@/views/reports/pickers/cores/add-new-column-dialog.vue';
import ImportDialog from '@/components/dialogs/import-dialog.vue';
import AffiliateNetworkFromTemplate from '@/views/reports/forms/affiliate_network/template.vue';
import TrafficSourceFromTemplate from '@/views/reports/forms/traffic_sources/template.vue';
import AddCustomCloakingDomainDialog from '@/views/settings/domains/forms/cloaking/add-custom-cloaking-domain-dialog.vue';
import AddCustomTrackingDomainDialog from '@/views/settings/domains/forms/tracking/add-custom-tracking-domain-dialog.vue';
import BulkEditCampaign from '@/views/reports/forms/campaign/bulk-edit.vue';
import BulkEditOffer from '@/views/reports/forms/offer/bulk-edit.vue';
import BulkEditLanding from '@/views/reports/forms/landing/bulk-edit.vue';
import ExchangeRatesDialog from '@/views/settings/general/forms/forms/exchange-rates-dialog.vue';
import ChangePassword from '@/views/settings/security/forms/password/change-password.vue';
import CreateApiKeys from '@/views/settings/security/forms/apikeys/create-api-keys.vue';
import EnableSecondFactor from '@/views/settings/security/forms/second-factor/enable.vue';
import DisableSecondFactor from '@/views/settings/security/forms/second-factor/disable.vue';
import ChangePlanDialog from '@/views/settings/subscription/forms/change-plan/change-plan.vue';
import PromoCode from '@/views/settings/subscription/forms/apply-promo/apply-promo.vue';
import UpdatePaymentMethodDialog from '@/views/settings/subscription/forms/update-payment-method/update-payment-method.vue';
import UpdateBillingInfoDialog from '@/views/settings/subscription/forms/update-billing-info/update-billing-info.vue';
import PaymentInformation from '@/views/settings/referral-program/forms/referral-balance/payment-information.vue';
import CreateCustomConversions from '@/views/settings/custom-conversions/forms/create-custom-conversions.vue';
import CreateWorkspaceDialog from '@/views/settings/multi-user-access/workspaces/forms/create-workspace-dialog.vue';
import CreateMember from '@/views/settings/multi-user-access/user-manager/forms/create-member-dialog.vue';
import CreateLinkDialog from '@/components/dialogs/create-link-dialog.vue';
import ItemsInWorkspace from '@/views/settings/multi-user-access/workspaces/forms/items-in-workspace.vue';
import GenerateLinks from '@/views/settings/custom-conversions/forms/generate-links.vue';
import EditAccessPermissions from '@/views/settings/multi-user-access/workspaces/forms/edit-access-permissions.vue';
import CreateRule from '@/views/reports/forms/campaign/rules/rules-form.vue';
import CreateIntegrationDialog from '@/views/settings/integrations/custom-integrations/forms/create-integration-dialog.vue';
import CreateIntegrationDialogFacebook from '@/views/settings/integrations/custom-integrations/forms/create-integration-dialog-facebook.vue';
import ChooseIntegrationDialog from '@/views/settings/integrations/custom-integrations/forms/choose-integration-dialog.vue';
import AddBotDetectionRules from '@/views/settings/bot-filters/forms/add-bot-detection-rules.vue';
import TwoFactorBackupCodeDialog from '@/views/pages/two-factor/two-factor-backup-code-dialog.vue';
import TemporaryPasswordDialog from '@/views/settings/temporary-password-dialog.vue';
import BookmarkAddDialog from '@/components/bookmark/bookmark-add-menu.vue';
import ManageAddon from './manage-addon/manage-addon.vue';
import CustomConversionsSending from './custom-conversions-sending.vue';
import ReportTotalSettings from './report-totals-settings.vue';
import ResendPostbacks from './resend-postbacks.vue';

import ConfirmDialog from '@/components/dialogs/confirm-dialog.vue'

import _ from 'lodash'
import Template from '@/views/reports/forms/traffic_sources/template.vue';

const modals = {
  ShareReportDialog,
  ExportCSV,
  CreateCampaign,
  EditCampaign,
  DuplicateCampaign,
  CreateOffer,
  EditOffer,
  DuplicateOffer,
  CreateLanding,
  EditLanding,
  DuplicateLanding,
  CreateFlow,
  EditFlow,
  DuplicateFlow,
  CreateTrafficSources,
  EditTrafficSource,
  ChangeWorkspace,
  ManageAddon,
  DuplicateTrafficSource,
  CreateAffiliateNetworks,
  EditAffiliateNetworks,
  DuplicateAffiliateNetworks,
  UpdateCost,
  CampaignLinks,
  LpPixel,
  TrackConversionsWithNoClickIds,
  ColumnsSettingsDialog,
  AddNewColumnDialog,
  ImportDialog,
  AffiliateNetworkFromTemplate,
  TrafficSourceFromTemplate,
  AddCustomCloakingDomainDialog,
  AddCustomTrackingDomainDialog,
  BulkEditCampaign,
  BulkEditOffer,
  BulkEditLanding,
  ExchangeRatesDialog,
  ChangePassword,
  CreateApiKeys,
  EnableSecondFactor,
  DisableSecondFactor,
  ChangePlanDialog,
  PromoCode,
  UpdatePaymentMethodDialog,
  UpdateBillingInfoDialog,
  PaymentInformation,
  CreateCustomConversions,
  CreateWorkspaceDialog,
  CreateMember,
  CreateLinkDialog,
  ItemsInWorkspace,
  GenerateLinks,
  EditAccessPermissions,
  CreateRule,
  CreateIntegrationDialog,
  CreateIntegrationDialogFacebook,
  ChooseIntegrationDialog,
  AddBotDetectionRules,
  TwoFactorBackupCodeDialog,
  TemporaryPasswordDialog,
  BookmarkAddDialog,
  CustomConversionsSending,
  ReportTotalSettings,
  ResendPostbacks,
  ConfirmDialog
}

@Component({
  components: {
    Template,
    ...modals,
  }
})
export default class Dialogs extends Vue {
  dialogsData: any = {};
  dialogs: any = []

  get modalKeys() {
    return Object.keys(modals)
  }

  mounted() {
    this.bus.on('open-dialog', this.onBusOpenDialog);
    this.bus.on('close-all-dialogs', this.onBusCloseAllDialogs);
  }

  beforeDestroy() {
    this.bus.off('open-dialog');
    this.bus.off('close-all-dialogs');
  }

  onBusOpenDialog({ name, data }) {
    if(!this.dialogs.includes(name)) {
      this.dialogsData[name] = data;
      this.dialogs.push(name)
    }
  }

  onBusCloseAllDialogs() {
    this.dialogs=[]
  }

  onClose(name) {
    this.dialogsData = _.omit(this.dialogsData, name)
    this.dialogs = this.dialogs.slice(0, -1)
  }

}
